import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { Transfer } from '../types';

interface RetryTargetRequest {
  operationId: string;
  targetId: string;
}

export function useRetryTarget() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ operationId, targetId }: RetryTargetRequest) =>
      apiClient.post<Transfer>(`/transfers/${operationId}:retryTarget`, { targetId }),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKeys.transfers.detail(data.operationId), data);
    },
  });
}
